import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUsers,
  FaUserTie,
  FaBoxOpen,
  FaWarehouse,
  FaUserCog,
  FaShoppingBag,
  FaFileInvoiceDollar,
  FaPenNib,
} from "react-icons/fa";
import Logo from "../assets/Images/sm2.png";
import "../styles/Dashboard.css";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const userData = useMemo(() => {
    try {
      const stored = localStorage.getItem("user");
      return stored ? JSON.parse(stored) : {};
    } catch (error) {
      console.error("Failed to parse user from localStorage", error);
      return {};
    }
  }, []);

  const isAdmin = `${userData?.role || ""}`.toLowerCase() === "admin";
  const permissions = {
    products: Boolean(userData?.products),
    quotation: Boolean(userData?.quotation),
    invoices: Boolean(userData?.invoices),
  };

  const links = useMemo(() => {
    const baseLinks = [
      { label: "Dashboard", to: "/dashboard", icon: <FaTachometerAlt /> },
      { label: "Buyers", to: "/buyers", icon: <FaUsers /> },
      {
        label: "Seller Branches",
        to: "/sellers",
        icon: <FaUserTie />,
        hideForUser: true,
      },
      {
        label: "Products",
        to: "/products",
        icon: <FaBoxOpen />,
        permissionKey: "products",
      },
      {
        label: "Inventory",
        to: "/inventory",
        icon: <FaWarehouse />,
        permissionKey: "products",
      },
      { label: "Users", to: "/users", icon: <FaUserCog />, hideForUser: true },
      {
        label: "Create Quotation",
        to: "/create-quotation",
        icon: <FaPenNib />,
        permissionKey: "quotation",
      },
      {
        label: "Quotations",
        to: "/quotation-list",
        icon: <FaShoppingBag />,
        permissionKey: "quotation",
      },

      {
        label: "Create Invoice",
        to: "/create-invoice",
        icon: <FaFileInvoiceDollar />,
        permissionKey: "invoices",
      },
      {
        label: "Invoices",
        to: "/invoices",
        icon: <FaFileInvoiceDollar />,
        permissionKey: "invoices",
      },
    ];

    if (isAdmin) return baseLinks;

    return baseLinks.filter((link) => {
      if (link.hideForUser) return false;
      if (!link.permissionKey) return true;
      return permissions[link.permissionKey];
    });
  }, [isAdmin, permissions]);

  const isActive = (path) =>
    path === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(path);

  return (
    <aside className="sidebar">
      <div className="sidebar__brand" onClick={() => navigate("/dashboard")}>
        <img src={Logo} alt="POS Logo" className="sidebar__logo" />
        <div>
          <p className="sidebar__brand-name">SMECON</p>
          <p className="sidebar__brand-sub">Invoice</p>
        </div>
      </div>

      <nav className="sidebar__nav">
        {links.map((link) => (
          <button
            key={link.to}
            type="button"
            onClick={() => navigate(link.to)}
            className={`sidebar__link ${isActive(link.to) ? "is-active" : ""}`}
          >
            <span className="sidebar__icon">{link.icon}</span>
            <span className="sidebar__label">{link.label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
}
